import PropTypes from 'prop-types'
import Spinner from 'react-bootstrap/Spinner'
import theme from '../../constants/theme'
import PrimaryButton from './PrimaryButton'

function FormDiscardButton({ handleClick, text, isLoading, ...rest }) {
  return (
    <PrimaryButton
      backgroundcolor={theme.talentinoWhiteBlue}
      hovercolor={theme.talentinoDarkerWhiteBlue}
      color={theme.brandColorOrange}
      onClick={handleClick}
      disabled={isLoading}
      width="auto"
      style={{ minWidth: '100px' }}
      {...rest}
    >
      {isLoading && (
        <Spinner
          animation="border"
          variant="primary"
          size="sm"
          className="me-2"
        />
      )}
      {text}
    </PrimaryButton>
  )
}

FormDiscardButton.propTypes = {
  handleClick: PropTypes.func,
  text: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
}

FormDiscardButton.defaultProps = {
  handleClick: () => {},
  isLoading: false,
}

export default FormDiscardButton
